// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5q-5";
export var imageContainer = "_5q-4";
export var metricsGrid = "_5q-2";
export var productDetailContainer = "_5q-1";
export var productListContainer = "_5q-0";
export var subscriberTableContainer = "_5q-3";